import React from 'react';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';

const IntegrationsView = ({ onViewToggle, obj, permissions }) => {
  const renderScreen = () => {
    return (
      <div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-value'>Request Details</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>API</div>
            <div className='details-value'>Lorem Ipsum</div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>API Version</div>
            <div className='details-value'>RESTv2</div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Status</div>
            <div className='details-value'>500</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Date & Time</div>
            <div className='details-value'>23/09/2022 - 11:09:23</div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Status Code</div>
            <div className='details-value'>500</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Request Start Time</div>
            <div className='details-value'>23/09/2022 - 11:09:23</div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Request End Time</div>
            <div className='details-value'>23/09/2022 - 11:09:45</div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Response Time</div>
            <div className='details-value'>2291ms</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-fluid'>
            <div className='details-label'>Request sent</div>
            <div className='details-value'>
              Dolor sit amet, consectetur adipiscing elit, sed do eiusmod.
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-fluid'>
            <div className='details-label'>Response received</div>
            <div className='details-value'>
              Dolor sit amet, consectetur adipiscing elit, sed do eiusmod.
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-6'>
            <div className='details-label'>Error Mesage</div>
            <div className='details-value'>----</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-6'>
            <div className='details-label'>Error Code</div>
            <div className='details-value'>----</div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <DetailViewLayout
        renderScreen={renderScreen}
        onViewToggle={onViewToggle}
        title={obj?.title}
        disableAvatar={true}
        copyDetails={true}
      />
    </>
  );
};

export default IntegrationsView;
